export default [
	{
		path: '/home',
		name: 'home',
		meta: { title: '首页', hidden: true },
		component: () => import('@/views/home/HomeView.vue')
	},
	{
		path: '/notFound',
		name: 'notFound',
		meta: { title: 'notFound', hidden: false },
		component: () => import('@/views/system/NotFound')
	},
	{
		path: '/roles/list',
		name: 'roles-list',
		meta: { title: '角色权限', hidden: false },
		component: () => import('@/views/system/RolesList')
	},
	{
		path: '/menu/list',
		name: 'menu-list',
		meta: { title: '菜单管理', hidden: false },
		component: () => import('@/views/system/MenuList')
	},
	{
		path: '/user/list',
		name: 'user-list',
		meta: { title: '系统账户', hidden: false },
		component: () => import('@/views/system/UserList')
	},
	{
		path: '/dept/list',
		name: 'dept-list',
		meta: { title: '部门组织', hidden: false },
		component: () => import('@/views/system/DeptList')
	},
];
